import { render, staticRenderFns } from "./myArticles.vue?vue&type=template&id=365bed45&"
import script from "./myArticles.vue?vue&type=script&lang=js&"
export * from "./myArticles.vue?vue&type=script&lang=js&"
import style0 from "./myArticles.vue?vue&type=style&index=0&id=365bed45&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports